import { useField } from 'formik';
import React from 'react';
import { isReadOnly } from 'utilities/JSUtil';
import './SelectList.scss';

const SelectList = ({ label, ...props }) => {
    const [field, meta, helpers] = useField(props);

    let classes = 'form-input-value'
    let mainClassName = ''
    let labelClass = ''
    let selectClass = ''

    let requiredLabel = undefined
    let error = undefined

    if (props.isrequired === 'true') {
        requiredLabel = '*'
    }

    if (props.mainClassName) {
        mainClassName += ' '+props.mainClassName
    }

    if (props.labelClass) {
        labelClass += ' '+props.labelClass
    }

    if (props.selectClass) {
        classes += ' '+props.selectClass
    }

    if (meta.error) {
        error = <div className='invalid'>{meta.error}</div>
    }

    return (
        <div id={props.id} className={'form-input'+mainClassName}>
            <label htmlFor={props.name} className={'form-input-label'+labelClass}>
                {label}{requiredLabel}
            </label>
            <div className={classes} style={{
                'borderRight': '1px solid rgb(118, 118, 118)',
                'borderRightStyle': 'inset',
                'overflowX': 'auto',
                'overflowY': 'auto',
                'minHeight': '101%'
            }}>
                <select {...field} name={props.name} title={props.title || label} size={props.size} id={props.id} multiple className={'select-list ' + props.className}
                    disabled={props.overridedisabledflag === 'true' ? false : (isReadOnly() || props.disabled)}>
                    {props.options.map((entry) => {
                        return <option key={entry.value} value={entry.value} title={entry.title || entry.label}>{entry.label}</option>
                    })}
                </select>
                {error}
            </div>
        </div>
    );
};

export default SelectList
